var _style, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumRisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84.9 310",
    style: {
      enableBackground: "new 0 0 84.9 310"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F6C494;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{opacity:0.2;}\n\t.st3{fill:#666768;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6C494",
    d: "M51.6,228.9V111.7H33.2v117.2C15.7,233,2.6,248.8,2.6,267.6c0,22,17.8,39.8,39.8,39.8 c22,0,39.8-17.8,39.8-39.8C82.2,248.8,69.2,233,51.6,228.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.7,301.5c5.6,3,11.9,4.7,18.7,4.7c22,0,39.8-17.8,39.8-39.8c0-4.1-0.6-8-1.8-11.7 C74,280.6,51.3,300.1,23.7,301.5z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M15.5,260.1c-0.1,0-0.2,0-0.3,0c-1.3-0.2-2.2-1.4-2-2.7c1.1-7.3,6.3-13.6,13.4-15.9c1.2-0.4,2.6,0.3,3,1.5 c0.4,1.2-0.3,2.6-1.5,3c-5.4,1.8-9.4,6.5-10.2,12.1C17.6,259.3,16.6,260.1,15.5,260.1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#666768",
    d: "M42.4,310C19,310,0,291,0,267.6c0-19.1,12.5-35.5,30.6-40.7v-215C30.6,5.3,35.9,0,42.4,0 c6.5,0,11.8,5.3,11.8,11.8v215c18.1,5.2,30.6,21.7,30.6,40.7C84.9,291,65.8,310,42.4,310z M42.4,5.3c-3.6,0-6.6,2.9-6.6,6.6v219.1 l-2,0.5c-16.8,4-28.6,18.9-28.6,36.2c0,20.5,16.7,37.2,37.2,37.2c20.5,0,37.2-16.7,37.2-37.2c0-17.3-11.8-32.2-28.6-36.2l-2-0.5 V11.8C49,8.2,46,5.3,42.4,5.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumRisk);
export default __webpack_public_path__ + "static/media/medium-risk.883a82808f549642fc19e4b49eefab56.svg";
export { ForwardRef as ReactComponent };